export default __webpack_public_path__ + "static/governance_policies_box_d-f22ecca7492ca471d6e8ecece27e1099.png";